<template>
  <div class="body">
    <templateHeader />
    <div>
      <router-view :key="$route.fullPath"></router-view>
    </div>
    <templateFooter />
  </div>
</template>

<script>
import templateHeader from "./templateHeader";
import templateFooter from "./templateFooter";
export default {
  name: "Home",
  components: {
    templateHeader,
    templateFooter,
  },
  data() {
    return {};
  },

  mounted() {

  },
};
</script>
<style lang="scss" scoped>
  .body{
    color: #5c5c5c;
    font-family: "微软雅黑";
    font-size: 14px;
    width: 100%;
    height: 100vh;
    overflow-y: scroll;
    background: url("../images/content-bg.jpg") no-repeat;
    position: relative;
    z-index: 1;
  }
</style>
